// Centralized dropdown options for the application
// This file contains all dropdown value/label mappings for reusability and maintenance

// Skills options
export const skillOptions = [
  { value: 'bricklaying', label: 'Bricklaying' },
  { value: 'carpentry', label: 'Carpentry' },
  { value: 'concreting', label: 'Concreting' },
  { value: 'demolition', label: 'Demolition' },
  { value: 'drainage', label: 'Drainage' },
  { value: 'drilling', label: 'Drilling' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'excavation', label: 'Excavation' },
  { value: 'fencing', label: 'Fencing' },
  { value: 'first_aid', label: 'First Aid' },
  { value: 'formwork', label: 'Formwork' },
  { value: 'general_labor', label: 'General Labor' },
  { value: 'landscaping', label: 'Landscaping' },
  { value: 'machine_operation', label: 'Machine Operation' },
  { value: 'painting', label: 'Painting' },
  { value: 'plumbing', label: 'Plumbing' },
  { value: 'roofing', label: 'Roofing' },
  { value: 'safety_management', label: 'Safety Management' },
  { value: 'scaffolding', label: 'Scaffolding' },
  { value: 'steel_fixing', label: 'Steel Fixing' },
  { value: 'tiling', label: 'Tiling' },
  { value: 'welding', label: 'Welding' },
  { value: 'cleaning', label: 'Cleaning' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'kitchen_hand', label: 'Kitchen Hand' },
  { value: 'security', label: 'Security' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'factory_work', label: 'Factory Work' },
  { value: 'construction', label: 'Construction' }
];

// Experience options
export const experienceOptions = [
  { value: 'entry', label: 'Entry Level (0-1 years)' },
  { value: 'intermediate', label: 'Some Experience (1-3 years)' },
  { value: 'experienced', label: 'Experienced (3+ years)' }
];

// Availability options
export const availabilityOptions = [
  { value: 'immediate', label: 'Immediate Start' },
  { value: '1week', label: 'Within 1 Week' },
  { value: '2weeks', label: 'Within 2 Weeks' },
  { value: '1month', label: 'Within 1 Month' }
];

// Salary options
export const salaryOptions = [
  { value: 'negotiable', label: 'Negotiable' },
  { value: '25-30', label: '$25-30/hour' },
  { value: '30-35', label: '$30-35/hour' },
  { value: '35-40', label: '$35-40/hour' },
  { value: '40-45', label: '$40-45/hour' },
  { value: '45-50', label: '$45-50/hour' },
  { value: '50+', label: '$50+/hour' }
];

// Visa status options
export const visaOptions = [
  { value: 'citizen', label: 'Australian Citizen' },
  { value: 'pr', label: 'Permanent Resident' },
  { value: 'working', label: 'Working Visa' },
  { value: 'student', label: 'Student Visa' },
  { value: 'other', label: 'Other' }
];

// Transport options
export const transportOptions = [
  { value: 'car', label: 'Own Car' },
  { value: 'public', label: 'Public Transport' },
  { value: 'bike', label: 'Bicycle' },
  { value: 'walking', label: 'Walking Distance Only' }
];

// Industry options
export const industryOptions = [
  { value: 'construction', label: 'Construction' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'logistics', label: 'Logistics & Warehousing' },
  { value: 'hospitality', label: 'Hospitality' },
  { value: 'retail', label: 'Retail' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'agriculture', label: 'Agriculture' },
  { value: 'mining', label: 'Mining' },
  { value: 'cleaning', label: 'Cleaning Services' },
  { value: 'security', label: 'Security Services' },
  { value: 'other', label: 'Other' }
];

// Company size options
export const companySizeOptions = [
  { value: 'startup', label: 'Startup (1-10 employees)' },
  { value: 'small', label: 'Small (11-50 employees)' },
  { value: 'medium', label: 'Medium (51-200 employees)' },
  { value: 'large', label: 'Large (201+ employees)' }
];


// Urgency options
export const urgencyOptions = [
  { value: 'low', label: 'Low - Within 1 month' },
  { value: 'medium', label: 'Medium - Within 2 weeks' },
  { value: 'high', label: 'High - Within 1 week' },
  { value: 'urgent', label: 'Urgent - ASAP' }
];

// Communication channel options
export const communicationChannelOptions = [
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'sms', label: 'SMS' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'platform', label: 'Platform Messages' }
];

// Yes/No options
export const yesNoOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' }
];

// English level options
export const englishLevelOptions = [
  { value: 'beginner', label: 'Beginner' },
  { value: 'elementary', label: 'Elementary' },
  { value: 'pre_intermediate', label: 'Pre-Intermediate' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'upper_intermediate', label: 'Upper-Intermediate' },
  { value: 'advanced', label: 'Advanced' },
  { value: 'fluent', label: 'Fluent' },
];

// Country of origin options (common countries for Australian labour market)
export const countryOptions = [
  'Afghanistan', 'Argentina', 'Australia', 'Bangladesh', 'Brazil', 'Cambodia',
  'Canada', 'Chile', 'China', 'Colombia', 'East Timor', 'Ecuador', 'Egypt',
  'El Salvador', 'Ethiopia', 'Fiji', 'France', 'Germany', 'Ghana', 'Greece',
  'Guatemala', 'Honduras', 'Hong Kong', 'India', 'Indonesia', 'Iran', 'Iraq',
  'Ireland', 'Israel', 'Italy', 'Japan', 'Jordan', 'Kenya', 'South Korea',
  'Lebanon', 'Malaysia', 'Mexico', 'Myanmar', 'Nepal', 'Netherlands',
  'New Zealand', 'Nigeria', 'Pakistan', 'Papua New Guinea', 'Peru',
  'Philippines', 'Poland', 'Portugal', 'Romania', 'Russia', 'Samoa',
  'Saudi Arabia', 'Singapore', 'Solomon Islands', 'Somalia', 'South Africa',
  'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Sweden', 'Syria', 'Taiwan',
  'Thailand', 'Tonga', 'Turkey', 'Ukraine', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Uruguay', 'Vanuatu', 'Venezuela',
  'Vietnam', 'Zimbabwe',
];

// Native language options (common languages in Australian labour market)
export const languageOptions = [
  'Amharic', 'Arabic', 'Bengali', 'Burmese', 'Cantonese', 'Croatian',
  'Dari', 'Dutch', 'English', 'Fijian', 'Filipino / Tagalog', 'French',
  'German', 'Greek', 'Gujarati', 'Hakka', 'Hazaragi', 'Hindi', 'Hmong',
  'Indonesian', 'Italian', 'Japanese', 'Kannada', 'Khmer', 'Korean',
  'Kurdish', 'Lao', 'Macedonian', 'Malay', 'Malayalam', 'Mandarin',
  'Marathi', 'Nepali', 'Pashto', 'Persian / Farsi', 'Polish', 'Portuguese',
  'Punjabi', 'Romanian', 'Russian', 'Samoan', 'Serbian', 'Sinhalese',
  'Somali', 'Spanish', 'Swahili', 'Swedish', 'Tamil', 'Telugu', 'Thai',
  'Tigrinya', 'Tongan', 'Turkish', 'Ukrainian', 'Urdu', 'Vietnamese',
  'Yoruba',
];

// Labour requirements (certifications and attributes)
export const labourRequirements = [
  // Licenses and Certifications
  'White Card (Construction Induction)',
  'Working at Heights Certificate',
  'Confined Space Entry',
  'Rigging License (Basic/Intermediate)',
  'Dogging License',
  'Scaffolding Certificate',
  'Asbestos Awareness Training',
  'Forklift License (LF/LO)',
  'Elevated Work Platform (EWP) License',
  'First Aid Certificate',
  'CPR Certificate',
  'Manual Handling Certificate',
  'Traffic Control Certificate',
  'RSA (Responsible Service of Alcohol)',
  'Food Handling Certificate',
  'Crane Operator License',
  'Welding Certification',
  'Electrical License',
  'Plumbing License',
  'Security License',
  'Australian Driver License',
  
  // Safety Equipment
  'Full PPE Uniform',
  'Safety Boots',
  'High Visibility Clothing',
  'Hard Hat/Safety Helmet',
  'Safety Glasses/Goggles',
  
  // Personal Attributes
  'Good English Communication',
  'Physical Fitness',
  'Drug & Alcohol Testing Clearance',
  'Police Check'
];

// Common requirements that apply to all skills
export const commonRequirements = [
  'First Aid Certificate',
  'CPR Certificate',
  'Good English Communication',
  'Physical Fitness',
  'Drug & Alcohol Testing Clearance',
  'Police Check'
];

// Skill-specific requirements mapping (keyed by skill VALUE for consistency with stored data)
export const skillRequirementsMap = {
  'construction': [
    'White Card (Construction Induction)',
    'Working at Heights Certificate',
    'Confined Space Entry',
    'Rigging License (Basic/Intermediate)',
    'Dogging License',
    'Scaffolding Certificate',
    'Asbestos Awareness Training',
    'Full PPE Uniform',
    'Safety Boots',
    'High Visibility Clothing',
    'Hard Hat/Safety Helmet',
    'Safety Glasses/Goggles'
  ],
  'cleaning': [
    'Police Check',
    'Good English Communication',
    'Physical Fitness',
    'Drug & Alcohol Testing Clearance'
  ],
  'landscaping': [
    'Australian Driver License',
    'Physical Fitness',
    'First Aid Certificate',
    'Manual Handling Certificate',
    'Drug & Alcohol Testing Clearance'
  ],
  'warehouse': [
    'Forklift License (LF/LO)',
    'Manual Handling Certificate',
    'Safety Boots',
    'High Visibility Clothing',
    'Drug & Alcohol Testing Clearance',
    'Physical Fitness'
  ],
  'kitchen_hand': [
    'Food Handling Certificate',
    'Good English Communication',
    'Physical Fitness',
    'Drug & Alcohol Testing Clearance'
  ],
  'security': [
    'Police Check',
    'Security License',
    'Good English Communication',
    'Drug & Alcohol Testing Clearance',
    'Physical Fitness'
  ],
  'delivery': [
    'Australian Driver License',
    'Good English Communication',
    'Physical Fitness',
    'Drug & Alcohol Testing Clearance'
  ],
  'factory_work': [
    'Manual Handling Certificate',
    'Safety Boots',
    'Safety Glasses/Goggles',
    'Drug & Alcohol Testing Clearance',
    'Physical Fitness'
  ],
  'painting': [
    'Working at Heights Certificate',
    'Safety Boots',
    'Safety Glasses/Goggles',
    'Drug & Alcohol Testing Clearance',
    'Physical Fitness'
  ],
  'electrical': [
    'Electrical License',
    'Working at Heights Certificate',
    'Safety Boots',
    'Safety Glasses/Goggles',
    'Drug & Alcohol Testing Clearance'
  ],
  'plumbing': [
    'Plumbing License',
    'Confined Space Entry',
    'Safety Boots',
    'Drug & Alcohol Testing Clearance'
  ],
  'carpentry': [
    'Working at Heights Certificate',
    'Manual Handling Certificate',
    'Safety Boots',
    'Safety Glasses/Goggles',
    'Drug & Alcohol Testing Clearance'
  ],
  'concreting': [
    'Manual Handling Certificate',
    'Safety Boots',
    'Safety Glasses/Goggles',
    'Drug & Alcohol Testing Clearance',
    'Physical Fitness'
  ],
  'demolition': [
    'White Card (Construction Induction)',
    'Working at Heights Certificate',
    'Asbestos Awareness Training',
    'Full PPE Uniform',
    'Safety Boots',
    'Hard Hat/Safety Helmet',
    'Safety Glasses/Goggles',
    'Drug & Alcohol Testing Clearance'
  ],
  'general_labor': [
    'White Card (Construction Induction)',
    'Australian Driver License',
    'Forklift License (LF/LO)',
    'Elevated Work Platform (EWP) License',
    'First Aid Certificate',
    'CPR Certificate',
    'Manual Handling Certificate',
    'Full PPE Uniform',
    'Safety Boots',
    'High Visibility Clothing',
    'Hard Hat/Safety Helmet',
    'Safety Glasses/Goggles',
    'Good English Communication',
    'Physical Fitness',
    'Drug & Alcohol Testing Clearance',
    'Police Check',
    'Working at Heights Certificate',
    'Confined Space Entry',
    'Rigging License (Basic/Intermediate)',
    'Dogging License',
    'Traffic Control Certificate',
    'RSA (Responsible Service of Alcohol)',
    'Food Handling Certificate',
    'Asbestos Awareness Training',
    'Crane Operator License',
    'Scaffolding Certificate',
    'Welding Certification'
  ]
};

// Utility functions to get labels from values
export const getSkillLabel = (value) => {
  const option = skillOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getExperienceLabel = (value) => {
  const option = experienceOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getAvailabilityLabel = (value) => {
  const option = availabilityOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getSalaryLabel = (value) => {
  const option = salaryOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getVisaLabel = (value) => {
  const option = visaOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getTransportLabel = (value) => {
  const option = transportOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getIndustryLabel = (value) => {
  const option = industryOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getCompanySizeLabel = (value) => {
  const option = companySizeOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};


export const getUrgencyLabel = (value) => {
  const option = urgencyOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getCommunicationChannelLabel = (value) => {
  const option = communicationChannelOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getYesNoLabel = (value) => {
  const option = yesNoOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

export const getEnglishLevelLabel = (value) => {
  const option = englishLevelOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};

// Helper function to get multiple skill labels
export const getSkillLabels = (values) => {
  if (!Array.isArray(values)) return [];
  return values.map(value => getSkillLabel(value));
};
